module.exports = __webpack_public_path__ + "static/media/DigitalDisplayCut.1f039c07.gif";